/**
 * mailtoBuilder — Canonical mailto: URI builder for Accrezeo-OS.
 *
 * WHY encodeURIComponent IS MANDATORY HERE:
 *   URLSearchParams.toString() serialises key-value pairs using the
 *   application/x-www-form-urlencoded algorithm, which encodes every space
 *   as a '+' character. Mail clients that parse mailto: URIs treat '+' as a
 *   literal plus sign — not a space — so an email body that begins with
 *   "Hi Firstname," arrives as "Hi+Firstname," in the draft window.
 *
 *   This was the root cause of the Tracxn LiveDeals email garble first
 *   observed in May 2026 (see docs/handoffs/TRACXN_EMAIL_GARBLE_ROOT_CAUSE.md).
 *   encodeURIComponent encodes spaces as '%20', which mailto: clients decode
 *   correctly to a space.
 *
 * THIS IS THE CANONICAL BUILDER.
 *   Do not reintroduce per-component mailto builders — the three-file
 *   divergence that produced this regression is removed entirely by this WI.
 *   All components that build mailto: links must import from this module.
 *
 * @param {string|null|undefined} to      - Email recipient address (may be empty/null)
 * @param {string|null|undefined} subject - Email subject line
 * @param {string|null|undefined} body    - Email body text
 * @returns {string}  A mailto: URI with subject and body safely encoded
 */
export function buildMailtoHref(to, subject, body) {
    const encodedSubject = encodeURIComponent(subject != null ? subject : '');
    const encodedBody = encodeURIComponent(body != null ? body : '');
    const recipient = to || '';
    return `mailto:${recipient}?subject=${encodedSubject}&body=${encodedBody}`;
}
